import {useState, useEffect} from 'react';
import { changeDisable, custom, getPermission, showMessageError } from '../../../classes/functions';
import './index.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import Modal from 'react-modal';
import ModalConfirmation from '../../../components/Modal/ModalConfirmation/index.js';

export default function People(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [cgc, setCgc] = useState('');
  const [nome_fantasia, setNomeFantasia] = useState('');
  const [status, setStatus] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [allWarehouses, setAllWarehouses] = useState([]);
  const [allWarehousesAndAddresses, setAllWarehousesAndAddresses] = useState([]);
  const [existingWarehouseAndAddress, setExistingWarehouseAndAddress] = useState([]);
  const [existingAddress, setExistingAddress] = useState({});
  const [branches, setBranches] = useState([]);
  const [showModals, setShowModals] = useState({
    generateAddress: false,
    confirmationAddress: false,
    deleteEmployee: false
  });
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  useEffect(()=> {
    async function loadPeople(){
      if (id) {
        getOne(id, option);

        return true;
      }

      getData('');

      return true;
    }

    loadPeople();
  }, []);

  function validForm() {
    setEmpresas(empresas.map((company) => {
      branches.map((branch) => {
        if(branch?.armazem_endereco?.armazem_endereco?.WAREHOUSE_ID){
          company.armazem = branch.armazem_endereco.armazem_endereco.WAREHOUSE_ID;
        }
      })

      return company;
    }));

    if ((cgc !== '') && (nome_fantasia !== '') && status !== '' && branches?.filter((branch) => branch.checked)?.length !== 0) {
      return true;
    } else {
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();

    const convertingBranchToAPIModel = () => {
      return branches.map((branch) => {
              let warehouseAndAddressID = branch?.armazem_endereco?.armazem_endereco?.ID;

              if(warehouseAndAddressID){
                branch.armazem_endereco.id = warehouseAndAddressID;

                delete branch.armazem_endereco.armazem_endereco;
                delete branch.armazem_endereco.pessoa_filial;
              }

              return branch;
            });
    }

    if (validForm() === true) {
      const data = {
        row: {
          cgc: cgc,
          nome_fantasia: nome_fantasia,
          razao_social: nome_fantasia,
          arquetipo: ['007'],
          filiais: convertingBranchToAPIModel()
        }
      }

      if (id) { 
        data.row.id = id;
        api.put("/api/people/put", data)
        .then((response) => {
            toast.success('Registro atualizado com sucesso.');
            history.push('/employees');
          }
        ).catch((error) => {
          setCarrying(false);

          showMessageError(error.response.data);
        });
      } else {
        api.post("/api/people/post", data)
        .then((response) => {
            toast.success('Registro inserido com sucesso.');
            history.push('/employees');
          }
        ).catch((error) => {
          setCarrying(false);

          showMessageError(error.response.data);
        });
      }
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      setCarrying(false);
    }
  }

  function getOne(id, option){
    api.get(`/api/people/getList?id=${id}&acceptsInative=${true}`)
    .then((response) => {
        setCgc(response.data.row.cgc);
        setNomeFantasia(response.data.row.nome_fantasia);
        setStatus(response.data.row.ativo === 'S' ? 'Ativo' : 'Inativo');

        response.data.row.filiais.map((filial) => {
          filial.checked = true;
          filial.deleted = "";

          return filial;
        });
        
        getData(response.data.row.filiais);

        setCarrying(false);
      }
    ).catch((error) => {
      console.log(error);
      showMessageError(error.response.data);

      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/employees');
  }

  function remove(){
    api.delete("/api/people/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/employees');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function changeCompaniesAndGetWarehouses(e) {
    let company = {id: e.target.value, nome_fantasia: "", checked: false};

    empresas.forEach((element) => {
      if (element.id === parseInt(e.target.value)) {
        element.checked = !element.checked;

        company.nome_fantasia = element.nome_fantasia;
        company.checked = element.checked;
      }
      return element;
    });

    changeBranch(company);
  }

  function changeBranch(company){
    let branchIsEmpty = (branches.length === 0);
    let thisBranchExists = false;

    getPerWarehouses(company.id);

    if(branchIsEmpty){
      return setBranches([...branches, {filial: parseInt(company.id), nome_fantasia: company.nome_fantasia, checked: company.checked}]);
    }

    setBranches(branches.map((branch) => {
      if(branch?.filial === parseInt(company.id)){
        thisBranchExists = true;

        branch.checked = company.checked;
        branch.nome_fantasia = company.nome_fantasia;

        if(branch.deleted === "" && !branch.checked){
          branch.deleted = "*";
        }
      }

      return branch;
    }));

    if(!thisBranchExists){
      setBranches([...branches, {filial: parseInt(company.id), nome_fantasia: company.nome_fantasia, checked: company.checked}]);
    }
  }

  function getData(filiais){
      api.get("/api/companies/getList")
          .then((response) => {
            if(filiais !== ''){
              filiais.map((branch) => {
                response.data.map((company) => {
                  if(parseInt(company.id) === parseInt(branch.filial)){
                    company.pessoa = branch.pessoa;
                    company.checked = true;

                    branch.nome_fantasia = company.nome_fantasia;
                  }

                  return company;
                });

                getPerWarehouses(branch?.filial);

                if(branch?.armazem_endereco?.armazem_endereco?.WAREHOUSE_ID){
                  getAddresses(branch?.armazem_endereco?.armazem_endereco?.WAREHOUSE_ID);
                }

                return branch;
              });

              setBranches(filiais);
            }

              setEmpresas(response.data);
              setCarrying(false);
          }).catch((error) => {
              showMessageError(error.response.data);
              setCarrying(false);
          });
  }

  function checkIfArrayExistsOnArray(array, setArray, property, object){
    let objectAlreadyExists = false;
        
    array?.map((ArrayOfOneArray) => {
      ArrayOfOneArray.map((currentArray) => {
        if(currentArray[property] === object[property]){
          objectAlreadyExists = true;
        }
      });
    });

    if(!objectAlreadyExists){
      setArray((prevState) => [...prevState, object]);
    }
  }

  function getAddresses(armazemId) {
      api
      .get(`/api/warehouses/${armazemId}/addresses`)
      .then((response) => {
        checkIfArrayExistsOnArray(allWarehousesAndAddresses, setAllWarehousesAndAddresses, "armazem_endereco_id", response.data);
      })
      .catch((error) => {
        showMessageError(error.response.data);
      });
  }

  function getPerWarehouses(companyId) {
    api
        .get(`/api/warehouses/getWarehousesFromFunctionary/${companyId}`)
        .then((response) => {
          let warehouseIsEmpty = (allWarehouses.length === 0);
          let warehouseWithThisCompanyExists = false;

          if(warehouseIsEmpty){
            return setAllWarehouses((prevState) => [...prevState, response.data]);
          }
        
          allWarehouses.map((warehousesOfOneCompany) => {
            if(warehousesOfOneCompany[0]?.empresa === companyId){
              warehouseWithThisCompanyExists = true;
            }
          });

          if(!warehouseWithThisCompanyExists){
            return setAllWarehouses((prevState) => [...prevState, response.data]);
          }
        })
        .catch((error) => {
            showMessageError(error.response.data);
        });
  }

  function getExistingValue(e){
    e.preventDefault();

    setBranches(branches.map((branch) => {
      if(!branch.armazem_endereco){
        branch.armazem_endereco = {armazem_endereco: {}};
      }

      allWarehouses.map((warehousesOfOneCompany) => {
        warehousesOfOneCompany.map((warehouse) => {
          existingWarehouseAndAddress.map((warehouseAndAddressOfOneCompany) => {
            warehouseAndAddressOfOneCompany.map((warehouseAndAddress) => {
              if(warehouse.empresa === branch.filial && warehouse.id === warehouseAndAddress?.address?.WAREHOUSE_ID){
                branch.armazem_endereco.armazem_endereco.WAREHOUSE_ID = warehouse.id;
              }
            });
          });
        });
      });

      allWarehousesAndAddresses.map((warehousesAndAddressesOfOneCompany) => {
        warehousesAndAddressesOfOneCompany.map((warehouseAndAddress) => {
          if(warehouseAndAddress.empresa === branch.filial && warehouseAndAddress.descricao === (nome_fantasia.split(" ")[0] + cgc)){
            branch.armazem_endereco.armazem_endereco.ENDERECO_ID = warehouseAndAddress.id;
            branch.armazem_endereco.armazem_endereco.ID = warehouseAndAddress.armazem_endereco_id;
          }
        });
      });
      
      return branch;
    }));

    setShowModals((prevState) => ({...prevState, confirmationAddress: false}));
  }

  function generateAddress(e){
    e.preventDefault();

    setShowModals((prevState) => ({...prevState, generateAddress: false, confirmationAddress: false}));
    
    return empresas.map((company) => {
      if(company.checked){
        const data = {
          nome: nome_fantasia,
          matricula: cgc,
          empresa: company?.id
        }

        if(id){
          data.funcionario = parseInt(id);
        }
        
        api
        .post("/api/adresses/employee", data)
        .then((response) => {
          if(response.data.status === 409){
            getAddresses(response.data.warehouse_address.address.WAREHOUSE_ID);
            return checkIfArrayExistsOnArray(existingWarehouseAndAddress, setExistingWarehouseAndAddress, "id", [response.data.warehouse_address]);
          }

          getAddresses(parseInt(response.data.armazem.codigo_armazem));
          
          setBranches(branches.map((branch) => {
            if(parseInt(response.data.endereco.empresa) === branch.filial){
              branch.armazem_endereco = {armazem_endereco: {WAREHOUSE_ID: 0, ENDERECO_ID: 0, ID: 0}}

              branch.armazem_endereco.armazem_endereco.WAREHOUSE_ID = parseInt(response.data.armazem.codigo_armazem);
              branch.armazem_endereco.armazem_endereco.ENDERECO_ID = parseInt(response.data.armazem.codigo_endereco);
              branch.armazem_endereco.armazem_endereco.ID = parseInt(response.data.armazem.id);
            }
                            
            return branch;
          }));
          
          return toast.success("Endereço cadastrado com sucesso.");
        }).catch((error) => {
          setCarrying(false);
          
          showMessageError(error.response.data);
        });
      }
    });
  }

  function checkIfItemExistsOnBranchAndInsert(type, value, companyID){
    let warehouseWasInserted = (type === "WAREHOUSE_ID");

    if(warehouseWasInserted){
      getAddresses(value);
    }

    setBranches(branches.map((branch) => {
      if(branch.filial === parseInt(companyID)){
        if(!branch.armazem_endereco){
          branch.armazem_endereco = {armazem_endereco: {[type]: value}}
        }

        branch.armazem_endereco.armazem_endereco[type] = value;
      }

      return branch;
    }))
  }

  useEffect(() => {
    if(!id){
      setCarrying(false);
    }
  }, []);

  useEffect(() => {
    if(allWarehousesAndAddresses.length !== 0 && existingWarehouseAndAddress.length !== 0){
      setShowModals((prevState) => ({...prevState, confirmationAddress: true}));
    }
  }, [allWarehousesAndAddresses, existingWarehouseAndAddress]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      <ModalConfirmation state={showModals.deleteEmployee} setState={setShowModals} stateName={'deleteEmployee'} custom={custom('500px', '250px')} title={'Deseja realmente excluir este funcionário?'} action={remove} param={''}/>

      <Modal
        isOpen={showModals.generateAddress}
        onRequestClose={() => setShowModals((prevState) => ({...prevState, generateAddress: false}))}
        style={customStyles}
        contentLabel='Modal de cadastro de endereço'
      >
        <div className="address-modal" style={{display: 'flex', flexDirection: 'column'}}>
          <h1 style={{fontWeight: '400'}}>Deseja gerar um endereço?</h1>
          <div className="formDiv" style={{display: 'flex', gap: '0.5rem', padding: 0}}>
            <button className="buttonSubmit" style={{height: 'auto'}} onClick={(e) => generateAddress(e)}>Salvar</button>
            <button className="buttonSubmit" style={{height: 'auto'}} onClick={() => setShowModals((prevState) => ({...prevState, generateAddress: false}))}>Fechar</button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showModals.confirmationAddress}
        onRequestClose={() => setShowModals((prevState) => ({...prevState, confirmationAddress: false}))}
        style={customStyles}
        contentLabel='Modal de confirmação de repetição de endereço'
      >
        <div className="adress-modal" style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
          <h1 style={{fontWeight: '400'}}>O endereço {existingAddress?.descricao} já foi cadastrado, deseja vincular ao funcionário?</h1>
          <div className="formDiv" style={{display: 'flex', gap: '0.5rem', padding: 0}}>
            <button className="buttonSubmit" style={{height: 'auto'}} onClick={(e) => getExistingValue(e)}>Vincular</button>
            <button className="buttonSubmit" style={{height: 'auto'}} onClick={() => setShowModals((prevState) => ({...prevState, confirmationAddress: false}))}>Fechar</button>
          </div>
        </div>
      </Modal>
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Funcionários">
          <Link to="/employees">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>Matrícula</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Matrícula" value={cgc} onChange={(e) => setCgc(e.target.value)} disabled={view || id} maxLength="18"/>
                </div>

                <div className="formDiv">
                  <label>Nome Completo</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Nome Completo" value={nome_fantasia} onChange={ (e) => setNomeFantasia(e.target.value) } disabled={view}/>
                </div>

                <div className="formDiv">
                  <label>Status</label>&nbsp;<label className="required">*</label><br/>
                  <select value={status} onChange={ (e) => setStatus(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    <option value="Ativo">Ativo</option>
                    <option value="Inativo">Inativo</option>
                  </select>
                </div>
              </div>
            </div>
            <br/>
            <div className="containerGroupData">
                <h2>Empresas&nbsp;<label className="required">*</label></h2>
                <hr></hr>
                <div className="divGroup">
                  <div className="formDivList">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Nome</th>
                          <th scope="col">Razão Social</th>
                          <th scope="col">Cidade</th>
                          <th scope="col">Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {empresas.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td data-label="#">
                                <input type="checkbox" checked={item.checked} value={item.id} onChange={(e) => changeCompaniesAndGetWarehouses(e)} />
                              </td>
                              <td data-label="Nome Fantasia">{item.nome_fantasia}</td>
                              <td data-label="Razão Social">{item.razao_social}</td>
                              <td data-label="Cidade">{item.cidade}</td>
                              <td data-label="Estado">{item.estado}</td>
                            </tr>
                        )})}
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <br />
            <div className="logistic containerGroupData" style={{display: `${empresas?.filter((company) => company?.checked).length !== 0 ? '' : 'none'}`}}>
              <div className="logistic__header">
                <h2 className="logistic___title">Logísticas&nbsp;</h2>
                <button onClick={() => setShowModals((prevState) => ({...prevState, generateAddress: true}))} type="button" style={{height: '35px', width: '10%'}} className="logistic___button buttonSubmit">Gerar endereço</button>
              </div>
              <hr></hr>
              <table className="logistic__table">
                <thead>
                  <tr>
                    <th>Empresa</th>
                    <th>Armazém</th>
                    <th>Endereço</th>
                  </tr>
                </thead>
                <tbody className="logistic___table-body">
                  {branches.map((company, index) => {
                    if(company?.checked){
                      return (
                        <tr className="logistic____table-row" key={index}>
                          <td className="logistic_____info">{company.nome_fantasia}</td>
                          <td className="logistic_____info">
                            <select className='formDiv' value={company?.armazem_endereco?.armazem_endereco?.WAREHOUSE_ID} onChange={(e) => checkIfItemExistsOnBranchAndInsert("WAREHOUSE_ID", parseInt(e.target.value), company.filial)} style={{ border: '1px solid #dce4ec', color: 'gray', padding: '0.5rem', borderRadius: '5px' }}>
                              <option value="">Selecione</option>
                              {allWarehouses?.map((warehousesOfOneCompany) => {
                                return warehousesOfOneCompany.map((warehouse, index) => {
                                  if(warehouse?.empresa === parseInt(company.filial)){
                                    return (
                                      <option value={warehouse?.id} key={index}>{warehouse?.descricao}</option>
                                    )
                                  }
                                })
                              })}
                            </select>
                          </td>
                          <td className="logistic_____info">
                            <select className='formDiv' value={company?.armazem_endereco?.armazem_endereco?.ID} onChange={(e) => checkIfItemExistsOnBranchAndInsert("ID", parseInt(e.target.value), company.filial)} style={{ border: '1px solid #dce4ec', color: 'gray', padding: '0.5rem', borderRadius: '5px' }}>
                              <option value="">Selecione</option>
                              {allWarehousesAndAddresses.map((warehouseAndAddressOfOneCompany) => {
                                return warehouseAndAddressOfOneCompany.map((warehouseAndAddress, index) => {
                                  if(warehouseAndAddress?.empresa === parseInt(company.filial) && company?.armazem_endereco?.armazem_endereco?.WAREHOUSE_ID === warehouseAndAddress?.armazem){

                                    return (
                                      <option value={warehouseAndAddress.armazem_endereco_id} key={index}>{warehouseAndAddress?.descricao}</option>
                                    )
                                  }
                                })
                              })}
                            </select>
                          </td>
                        </tr>
                      )
                    }
                  })}
                </tbody>
              </table>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CADASTROS - FUNCIONARIOS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('CADASTROS - FUNCIONARIOS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={() => setShowModals((prevState) => ({...prevState, deleteEmployee: true}))} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}